export enum ProgramViewTypes {
    SHOW_PROGRAM_VIEW_LOADING = "SHOW_PROGRAM_VIEW_LOADING",
    HIDE_PROGRAM_VIEW_LOADING = "HIDE_PROGRAM_VIEW_LOADING",

    REQUEST_PROGRAM_VIEW_INFO = "REQUEST_PROGRAM_VIEW_INFO",
    SET_PROGRAM_VIEW_INFO = "SET_PROGRAM_VIEW_INFO",
    SET_PROGRAM_VIEW_STATUS = "SET_PROGRAM_VIEW_STATUS",
    SET_CURRENT_STREAM = "SET_CURRENT_STREAM",
    SET_PROGRAM_LOCKED = "SET_PROGRAM_LOCKED",

    REQUEST_PROGRAM_STREAM_DATA = "REQUEST_PROGRAM_STREAM_DATA",
    SET_PROGRAM_STREAM_DATA = "SET_PROGRAM_STREAM_DATA",

    SET_PROGRAM_MESSAGE = "SET_PROGRAM_MESSAGE",
    CLEAR_PROGRAM_MESSAGE = "CLEAR_PROGRAM_MESSAGE",

    SET_PROGRAM_PLAYER_DATA = "SET_PROGRAM_PLAYER_DATA",
    CLEAR_PROGRAM_PLAYER_DATA = "CLEAR_PROGRAM_PLAYER_DATA",

    CLEAR_PROGRAM_VIEW_INFO = "CLEAR_PROGRAM_VIEW_INFO",

    START_PLAYBACK_REPORTING = "START_PLAYBACK_REPORTING",
    STOP_PLAYBACK_REPORTING = "STOP_PLAYBACK_REPORTING",
    DO_REPORT_PLAYBACK = "DO_REPORT_PLAYBACK",
    DO_REPORT_STATISTIC = "DO_REPORT_STATISTIC",

    SET_OTHER_SESSIONS = "SET_OTHER_SESSIONS",
    DECREASE_REAMININ_TIME = "DECREASE_REAMININ_TIME",

    CHECK_FORBIDDEN_IP = "CHECK_FORBIDDEN_IP",
    FORBIDDEN_IP_CHECKED = "FORBIDDEN_IP_CHECKED",

    TOGGLE_ECONOMIC = "TOGGLE_ECONOMIC",
    SET_PROMOTION = "SET_PROMOTION"
}